import React from "react";

export default function AppLoader() {
  return (
    <div style={{
      padding: "20px",
      textAlign: "center",
      fontSize: "18px",
      fontWeight: "500"
    }}>
      🔄 Connecting to ESevaLink services...
    </div>
  );
}
